<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import {
		celsius_to_fahrenheit,
		fahrenheit_to_celsius,
		isBluTRV,
		real_id,
	} from '../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Services
	import { gen2Request } from '../../../services/gen_2_http_reqs';
	//Stores
	//Design system components
	import { Text, Token, Loader } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../types/requests/settings/setting';
	import type { Device } from '../../../types/Device';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { requestEditDevice } from 'src/components/Lists/list-helpers';
	import { TEMPERATURE_SENSORS_IN_CELSIUS } from 'src/constants';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;

	const id = real_id(device.id),
		settings = $settingsStore,
		save = async () => {
			waitForResponse = true;
			if (TEMPERATURE_SENSORS_IN_CELSIUS.includes(device.type)) {
				let editDevice = {
					...device,
					ht_ui: { temperature_unit: selected },
				};

				if (isBluTRV(device?.type) && device?.temp_fav_positions) {
					editDevice = {
						...editDevice,
						temp_fav_positions: device?.temp_fav_positions.map((pos) => ({
							...pos,
							value:
								selected === 'C'
									? +fahrenheit_to_celsius(pos.value).toFixed(1)
									: celsius_to_fahrenheit(pos.value),
						})),
					};
				}

				await requestEditDevice(editDevice);
				waitForResponse = false;
			} else {
				const res: SettingRequest = await gen2Request(device, 'ht_ui.SetConfig', {
					config: { temperature_unit: selected },
				});
				onSettingsResponse(res, device);
				waitForResponse = false;
			}
		};

	let selected = settings?.ht_ui?.temperature_unit || device?.ht_ui?.temperature_unit || 'C',
		waitForResponse = false;
</script>

<Text styleType="body-small" class="mb-s">
	{$format('select_temperature_units', {
		default: 'Choose temperature units:',
	})}
</Text>

<div
	class={classMap({
		'd-flex': true,
		'justify-content-center': waitForResponse,
	})}
>
	{#if waitForResponse}
		<Loader size="m" class="align-self-center" />
	{:else}
		<Token
			id="token-05p4dod"
			selected={selected === 'C'}
			size="m"
			title="°C"
			class="mr-s"
			on:click={() => {
				if (selected !== 'C') {
					selected = 'C';
					save();
				}
			}}
		/>
		<Token
			id="token-dgbu5d6"
			selected={selected === 'F'}
			size="m"
			title="°F"
			on:click={() => {
				if (selected !== 'F') {
					selected = 'F';
					save();
				}
			}}
		/>
	{/if}
</div>
